export default {"src":"/_next/static/media/galvan_erc_20.4e3ee0db.svg","height":35,"width":35};